import React from 'react';
import PropTypes from 'prop-types';
import { TypeActionCodes, ReclamationActionDetailCodes, ReclamationActionDetailType } from 'constants.js';
import { connect } from 'react-redux';
import { addAction } from 'store/reclamation/reclamationsActions';
import AcknowledgeRegularisationStock from './AcknowledgeRegularisationStock';

class AcknowledgeRegularisationStockContainer extends React.Component {

    handleClickSave = () => {
        const { actionId, reclamationId, addAction } = this.props;

        let actionData = {
            code: TypeActionCodes.Reponse,
            parentReclamationActionId: actionId,
            details: [{
                code: ReclamationActionDetailCodes.Reponse,
                type: ReclamationActionDetailType.Texte,
                libelle: "Régularisation faite !",
                position: 0,
                valeurString: 'Régularisation faite !'
            }],
            reponseAttendue: false
        };


        addAction(reclamationId, actionData, actionId);
    }





    render() {
        const { isAdding } = this.props;

        return (
            <AcknowledgeRegularisationStock
                onClickSave={this.handleClickSave}
                isAdding={isAdding}                
            />
        );
    }
}

AcknowledgeRegularisationStockContainer.propTypes = {
    actionId: PropTypes.number.isRequired,
    reclamationId: PropTypes.number.isRequired
};




const mapStateToProps = (state, ownProps) => ({
    isAdding: state.common.addActionData.actionId === ownProps.actionId
});


const mapDispatchToProps = dispatch => ({
    addAction: (reclamationId, actionData, actionId) => dispatch(addAction(reclamationId, actionData, actionId))
});

export default connect(mapStateToProps, mapDispatchToProps)(AcknowledgeRegularisationStockContainer);